import React from "react";
import { Box, Container } from "@mui/material";
import PageTitle from "../common/PageTitle";

interface HubPageShellProps {
  pageTitle: string;
  pageDescription?: string;
  children: React.ReactNode;
  maxWidth?: "lg" | "xl";
}

const HubPageShell: React.FC<HubPageShellProps> = ({
  pageTitle,
  pageDescription,
  children,
  maxWidth = "xl",
}) => (
  <Box sx={{ minHeight: "100vh", bgcolor: "background.default" }}>
    <PageTitle
      pageTitle={pageTitle}
      pageDescription={pageDescription}
      maxWidth={maxWidth}
    />
    <Container maxWidth={maxWidth} sx={{ py: 3 }}>
      {children}
    </Container>
  </Box>
);

export default HubPageShell;
